"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.schedulerFor = exports.scheduler = void 0;

var Converters_1 = require("../check/arbitrary/definition/Converters");

var BuildSchedulerFor_1 = require("./_internals/helpers/BuildSchedulerFor");

var SchedulerArbitrary_1 = require("./_internals/SchedulerArbitrary");

function scheduler(constraints) {
  var _ref = constraints || {},
      _ref$act = _ref.act,
      act = _ref$act === void 0 ? function (f) {
    return f();
  } : _ref$act;

  return (0, Converters_1.convertFromNext)(new SchedulerArbitrary_1.SchedulerArbitrary(act));
}

exports.scheduler = scheduler;

function schedulerFor(customOrderingOrConstraints, constraintsOrUndefined) {
  var _ref2 = Array.isArray(customOrderingOrConstraints) ? constraintsOrUndefined || {} : customOrderingOrConstraints || {},
      _ref2$act = _ref2.act,
      act = _ref2$act === void 0 ? function (f) {
    return f();
  } : _ref2$act;

  if (Array.isArray(customOrderingOrConstraints)) {
    return (0, BuildSchedulerFor_1.buildSchedulerFor)(act, customOrderingOrConstraints);
  }

  return function (_strs) {
    for (var _len = arguments.length, ordering = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      ordering[_key - 1] = arguments[_key];
    }

    return (0, BuildSchedulerFor_1.buildSchedulerFor)(act, ordering);
  };
}

exports.schedulerFor = schedulerFor;